var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-empty',{attrs:{"image":"network","description":"服务器内部错误，请联系管理员"}})}
var staticRenderFns = []

export { render, staticRenderFns }